import { FieldSpec } from '@k2/common/k2-forms-state/types';
import { normalizeValueOption } from '@k2/common/k2-forms/utils';

export function optionsFormatter(field: FieldSpec): string {
  const options = field.attributes.valueOptions.map(normalizeValueOption);
  const selected = options.find(option => option.id === field.value);

  return selected === null || selected === undefined ? selected : selected.value;
}
